module.exports = __webpack_public_path__ + "static/media/34-13.ef242289.mp3";